export default __webpack_public_path__ + "static/media/Image type  Active - Hover.bedbd6aa.svg";